import React, { useEffect, useRef, useState } from "react";
import Search from "../../../../../../components/Search";
import { useDispatch, useSelector } from "react-redux";
import { Divider, Dropdown, Form, Select, Table } from "antd";
import svg27 from "../../../../../../assets/svg/svg27.svg";
import svg12 from "../../../../../../assets/svg/svg12.svg";
import svg13 from "../../../../../../assets/svg/svg13.svg";
import svg29 from "../../../../../../assets/svg/svg29.svg";
import CardLoading from "../../../../../../components/CardLoading";
import { Link, useNavigate } from "react-router-dom";
import { fetchData } from "../../../../../../features/fetch/fetchSlice";
import { formatText } from "../../../../../../utils";
import moment from "moment";
import useModalToggle from "../../../../../../custom_hooks/useModalToggle";
import PaymentAdd from "./modal/PaymentAdd";
import { cashConverter } from "../../../../../../utils";
import ConfirmModal from "../../../../../../components/ConfirmModal";
import toast from "react-hot-toast";
import { save } from "../../../../../../features/save/saveSlice";

function PaymentTable() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const url = "api/v2/mainProject/disbursement/get";
  const urlSymbol = "api/v2/moneySymbol/get";
  const { loading, data, count, activeObjOngoingProject } = useSelector(
    (state) => ({
      loading: state.fetch.loading,
      data: state.fetch.data[url] || [],
      activeObjOngoingProject: state.obj.activeObj["ongoingProject"],
      count: state.fetch.count[url] || 0,
    }),
  );
  const { refetchKey } = useSelector((state) => state.global);

  const { open, handleCancel, handleOpen } = useModalToggle();

  const [searchInput, setsearchInput] = useState(null);
  const [prodd, setProdd] = useState("");

  const handleSearch = (e) => {
    setsearchInput(e.target.value);
    dispatch(
      fetchData({
        url: url,
        pdDescription: e.target.value == "" ? null : e.target.value,
        pdProjectId: activeObjOngoingProject?.projectId,
      }),
    );
  };
  const [openDelete, setOpenDelete] = useState(false);
  const handleOpenDelete = () => {
    setOpenDelete(true);
  };
  const handleCloseDelete = () => {
    setOpenDelete(false);
  };

  const handleDelete = async () => {
    const res = await dispatch(
      save({
        url: "api/v2/mainProject/disbursement/delete",
        disbursementId: prodd?.disbursementId,
      }),
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.message);
      await setOpenDelete(false);
      await fetchTableData();
    } else {
      toast.error(res?.payload?.message);
    }
  };

  const handleEdit = async () => {
    await handleOpen();
  };
  const handleAdd = async () => {
    await setProdd();
    await handleOpen();
  };

  const settingItems = [
    {
      key: "1",
      label: (
        <div onClick={handleEdit}>
          <Link className="flex actions-text gap-x-[.75rem] my-2 w-4 h-4 ">
            <img src={svg12} alt="svg12" /> Edit
          </Link>
          <div className="mt-[1rem]">
            <Divider />
          </div>
        </div>
      ),
    },
    // {
    //   key: "2",
    //   label: (
    //     <div onClick={handleOpenDelete}>
    //       <Link className="flex items-center gap-x-2 actions-text my-2">
    //         <img src={svg13} alt="svg13" className="w-4 h-4" />
    //         <span className="whitespace-nowrap">Delete</span>
    //       </Link>
    //     </div>
    //   ),
    // },
  ];

  const columns = [
    {
      title: "#",
      dataIndex: "index",
      key: "index",
      render: (_, __, index) => index + 1,
    },
    {
      title: "Payment Description",
      dataIndex: "pdDescription",
      sorter: (a, b) => a.pdDescription.localeCompare(b.pdDescription),
    },

    {
      title: "Currency",
      dataIndex: "pdCurrencyCode",
      sorter: (a, b) => a.pdCurrencyCode.localeCompare(b.pdCurrencyCode),
    },
    {
      title: "Exchange Rate",
      dataIndex: "exchangeRate",
      sorter: (a, b) => a.exchangeRate.localeCompare(b.exchangeRate),
    },
    {
      title: "Amount",
      dataIndex: "pdAmount",
      render: (item) => {
        return <div>{cashConverter(item)}</div>;
      },
      sorter: (a, b) => a.pdAmount.localeCompare(b.pdAmount),
    },
    {
      title: "Converted Amount",
      dataIndex: "pdConvertedAmount",
      render: (item) => {
        return <div>{cashConverter(item)}</div>;
      },
      sorter: (a, b) => a.pdConvertedAmount.localeCompare(b.pdConvertedAmount),
    },
    {
      title: "Advance Repayment Amount",
      dataIndex: "pdAdvancedRepaymentAmount",
      render: (item) => {
        return <div>{cashConverter(item)}</div>;
      },
      sorter: (a, b) =>
        a.pdAdvancedRepaymentAmount.localeCompare(b.pdAdvancedRepaymentAmount),
    },
    {
      title: "Retained Amount",
      dataIndex: "pdRetainedRepaymentAmount",
      render: (item) => {
        return <div>{cashConverter(item)}</div>;
      },
      sorter: (a, b) =>
        a.pdRetainedRepaymentAmount.localeCompare(b.pdRetainedRepaymentAmount),
    },

    {
      title: "Payment Account",
      dataIndex: "paymentAccount",
      render: (item) => {
        return <div>{item}</div>;
      },
      sorter: (a, b) => a.paymentAccount.localeCompare(b.paymentAccount),
    },

    {
      title: "Last Updated By",
      dataIndex: "createdBy",
      sorter: (a, b) => a.createdBy.localeCompare(b.createdBy),
    },

    {
      title: "Paid Date",
      dataIndex: "paidDate",
      width: "150px",
      render: (text) => (text ? moment(text).format("DD-MM-YYYY") : "--"),
      sorter: (a, b) =>
        moment(a.paidDate).valueOf() - moment(b.paidDate).valueOf(),
    },
    {
      title: "Due Date",
      dataIndex: "pdDueDate",
      width: "150px",
      render: (text) => (text ? moment(text).format("DD-MM-YYYY") : "--"),
      sorter: (a, b) =>
        moment(a.pdDueDate).valueOf() - moment(b.pdDueDate).valueOf(),
    },

    {
      title: "Status",
      dataIndex: "pdStatus",
      width: "200px",
      render: (item) => {
        const colors = {
          PAID: "#28A745",
          PENDING_PAYMENT: "#3250FF",
        };

        return (
          <div
            className="text-[#FFF] inline-block rounded-[8px] px-[8px] py-[4px] w-auto !text-[12px]"
            style={{
              backgroundColor: colors[item] || "darkGreen",
            }}
          >
            {formatText(item)}
          </div>
        );
      },
    },

    ...(activeObjOngoingProject?.projectStatus != "STALLED"
      ? [
          {
            title: "Actions",
            render: (item) => (
              <>
                <Dropdown
                  overlayStyle={{
                    width: "250px",
                  }}
                  trigger={"click"}
                  menu={{ items: settingItems }}
                  placement="bottom"
                >
                  <button onClick={() => setProdd(item)}>
                    <img src={svg27} alt="svg27" />
                  </button>
                </Dropdown>
              </>
            ),
          },
        ]
      : []),
  ];

  const onFinish = () => {};

  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  async function fetchTableData(page, size) {
    await dispatch(
      fetchData({
        url: url,
        pdProjectId: activeObjOngoingProject?.projectId,
        limit: size ?? pageSize,
        start: page ?? pageIndex,
      }),
    );
  }

  useEffect(() => {
    if (refetchKey == 7) {
      fetchTableData();
      dispatch(
        fetchData({
          url: urlSymbol,
          limit: null,
          start: 0,
        }),
      );
    }
  }, [refetchKey]);

  if (loading && !searchInput) return <CardLoading />;
  return (
    <div className="flex flex-col w-full  flex-1">
      <div className="flex lg:flex-row flex-col lg:items-center justify-between  gap-y-4">
        <div className="form-add-h">Payments</div>
        <div className="flex flex-wrap items-center lg:justify-end justify-start gap-[.62rem]">
          <div className="lg:w-[16.125rem] w-full  ">
            <Search
              searchInput={searchInput}
              handleSearch={handleSearch}
              text={"Search"}
            />
          </div>
          {activeObjOngoingProject?.projectStatus === "STALLED" ? null : (
            <div className="w-[150px]">
              <button onClick={() => handleAdd()} className="cstm-btn-2">
                <img src={svg29} alt="svg29" />{" "}
                <span className="ml-1">Add Payment</span>
              </button>
            </div>
          )}
        </div>
      </div>

      <div className="max-w-full w-full overflow-x-auto">
        <Table
          rowSelection={false}
          className="mt-[1.75rem] w-full"
          scroll={{
            x: "auto",
          }}
          rowKey={(record) => record?.disbursementId}
          columns={columns}
          dataSource={data}
          loading={loading}
          pagination={{
            position: ["bottomRight"],
            current: pageIndex + 1,
            total: count,
            pageSize: pageSize,
            onChange: (page, size) => {
              setPageIndex(page - 1);
              setPageSize(size);
              fetchTableData(page - 1, size);
            },
            showSizeChanger: false,
            hideOnSinglePage: true,
          }}
          footer={() => {
            const totalAmount = data?.reduce(
              (sum, item) => sum + Number(item?.pdConvertedAmount || 0),
              0,
            );
            return (
              <div className="w-full bg-[#F1F3F5] py-[1.5625rem] px-[2.19rem] text-[#050505] font-[600] font-interSans text-[1rem]">
                <div className="grid grid-cols-[repeat(11,minmax(0,1fr))] w-full">
                  <span className="col-span-4">Total Disbursement (Kes)</span>
                  <span className="">{cashConverter(totalAmount)}</span>
                </div>
              </div>
            );
          }}
        />
      </div>

      <PaymentAdd
        isModalOpen={open}
        handleCancel={handleCancel}
        handleFetch={fetchTableData}
        prodd={prodd}
      />

      <ConfirmModal
        open={openDelete}
        handleCancel={handleCloseDelete}
        handleSubmit={handleDelete}
        loading={loading}
        content="Are you sure you want perfom this action?"
        type="alert"
        btnTitle="Delete"
      />
    </div>
  );
}

export default PaymentTable;
